var React = require('react');

function HomeMoreArrow (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M12.929 7.929c3.834-3.834 10.007-3.904 13.927-.21l.215.21L100 80.857l72.929-72.928c3.834-3.834 10.007-3.904 13.927-.21l.215.21c3.834 3.834 3.904 10.007.21 13.927l-.21.215-80 80c-3.834 3.834-10.007 3.904-13.927.21l-.215-.21-80-80c-3.905-3.905-3.905-10.237 0-14.142z","fill":"currentColor","fillRule":"nonzero"}));
}

HomeMoreArrow.defaultProps = {"viewBox":"0 0 200 110"};

module.exports = HomeMoreArrow;

HomeMoreArrow.default = HomeMoreArrow;
